import { FiUser, FiUsers } from 'react-icons/fi';

const OPTIONS = [
  { value: 'individual', label: 'Individual', icon: FiUser, description: 'Just for me' },
  { value: 'organization', label: 'Organization', icon: FiUsers, description: 'For my team' },
];

export default function AccountTypeToggle({ value, onChange }) {
  return (
    <div className="grid grid-cols-2 gap-3 rounded-2xl border border-line bg-surface p-1.5 dark:border-midnight-600 dark:bg-midnight-800">
      {OPTIONS.map((option) => {
        const active = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={`flex flex-col items-center gap-1 rounded-xl px-4 py-3 text-sm font-semibold transition ${
              active
                ? 'bg-white text-brand-700 shadow-card dark:bg-midnight-700 dark:text-brand-300'
                : 'text-muted hover:text-ink dark:text-subtle dark:hover:text-white'
            }`}
          >
            <option.icon size={18} />
            {option.label}
            <span className="text-xs font-normal text-subtle">{option.description}</span>
          </button>
        );
      })}
    </div>
  );
}
